import React from "react";
import { withTranslation } from "react-i18next";
import FailedWrapper from "./Failed.style";

import icon_error from "../../../../assets/images/icons/icon_error.svg"
import { Link } from "react-router-dom";

const Failed = (props) => {
  return (
    <FailedWrapper>
      <div className="payment-details-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="header-wrapper pt-5">
              <div className="image">
                  <img
                    src={icon_error}
                    alt=""
                  />
                </div>
                <div className="text">
                <h2>Thank you for choosing Tawuniya</h2>
                <p className="smaller">
                  An error has occurred in the payment process.<br />
                  {/* <p className="smaller">For more information please contact us on</p> */}
                  {/* <a href="mailto:SMEeSupport@tawuniya.com.sa">SMEeSupport@tawuniya.com.sa</a> */}
                </p>

                <Link to={'/renewal'}>Back to Renew</Link>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </FailedWrapper>
  );
};

export default withTranslation()(Failed);
